<template>
	<div>
		<employee-position-description 
			:employee-id="employeeId"
			:id="id" />
		
		<v-footer color app height="55" class="noPrint">
			<v-spacer></v-spacer>
			<footer-back-btn @click="backBtnClicked" />
		</v-footer>
	</div>
</template>

<script>
	import EmployeePositionDescription from '@/components/employee/EmployeePositionDescription';

	export default {
		name: 'PageEmployeePosition',
		components: {
			EmployeePositionDescription
		},
		props: {
			employeeId: {
				required: true
			},
			id: { // PD Id
				required: true
			}
		},
		methods: {
			backBtnClicked() {
				window.history.back();
			},
		}
	};
</script>

<style></style>
